var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeloTokenTvlAccent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 524,
    viewBox: "0 0 552 524",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54,
    filter: "url(#filter0_f_1_652)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 276,
    cy: 262,
    rx: 151,
    ry: 137,
    fill: "#19506F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_1_652)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 355,
    rx: 85,
    ry: 67,
    fill: "#BF2A63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_652",
    x: 0,
    y: 0,
    width: 552,
    height: 524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62.5,
    result: "effect1_foregroundBlur_1_652"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_652",
    x: 1,
    y: 214,
    width: 318,
    height: 282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37,
    result: "effect1_foregroundBlur_1_652"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloTokenTvlAccent);
export default __webpack_public_path__ + "static/media/velo-token-tvl-accent.d897716ca207728855b0b730d225b705.svg";
export { ForwardRef as ReactComponent };